import { router } from './../../../../shared/shared.global-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { computed, Injectable, Signal } from '@angular/core';
import { FolderGridItemObject, PersonGridItemObject, ServiceGridItemObject } from '@it2go/types';
import { selectServices } from '../../../../../store/global/global.selectors';
import { globalStore, isAllowed } from '../../../../shared/shared.global-service';
import { FilterBuilder } from '../../../helper/filter.builder';
import { folderPersonFrag } from 'packages/client/src/app/services/types/folder.types';
import { personFrag } from 'packages/client/src/app/services/types/person.types';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { selectCurrentService, selectCurrentServiceId } from '../../../store/person/person.selectors';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { folderUri } from '../../../../../utils/router.utils';

@Injectable()
export class UpsertPersonPageStore extends ComponentStoreV2Factory {

    public services = toSignal(globalStore!.select(selectServices));
    public serviceId = 0;
    public currentServiceId = toSignal(globalStore!.select(selectCurrentServiceId));

    public folder: Signal<FolderGridItemObject | null> = computed(() => this.data.getFolders()?.items?.[0] || null);
    public canEditPersonInfo: Signal<boolean> = isAllowed['person.update'];

    public hasMultipleWorkplaces$: Observable<boolean> = this.store!.select(selectCurrentService)
        .pipe(map((it: ServiceGridItemObject | null) => (it?.workplaces?.length || 0) > 1));

    constructor() {
        super();
    }

    public async goToDetail(personId: number): Promise<void> {
        const folder = await this.getFolderIdByPerson(personId, this.serviceId);

        router.navigateByUrl(folderUri(folder.id, this.serviceId));

    }

    public getFolderPerson({ id }: { id: number }): void {
        this.api.getFolders(FilterBuilder.filter({ id }), folderPersonFrag);
    }

    /** Jen kontext složky - schválně bez `person`, jinak by se formulář přepnul do editace. */
    public getFolderContext({ id }: { id: number }): void {
        this.api.getFolders(FilterBuilder.filter({ id }), 'id serviceId');
    }

    /** Další osoba složky - formulář ji potřebuje ve stejném tvaru jako `folder.person`. */
    public async getPerson(id: number): Promise<PersonGridItemObject | null> {
        const result = await this.api.getPersons(FilterBuilder.filter({ id }), `${personFrag} dietSpec`);

        return result?.items?.[0] || null;
    }

    public async goToFolderDashboard(folderId: number): Promise<void> {
        const serviceId = this.currentServiceId() || this.folder()?.serviceId;
        await router.navigateByUrl(folderUri(folderId, serviceId, 'dashboard'));
    }

    public async getFolderIdByPerson(personId: number, serviceId: number): Promise<{ id: number }> {
        const folders = await this.api.getFolders(FilterBuilder.filter({
            serviceId,
            personId,
        }), 'id');
        return folders.items![0];
    }
}
